import React from 'react';

function ResultDisplay({ result, error }) {
  if (error) {
    return (
      <div style={{
        backgroundColor: '#f8d7da',
        color: '#721c24',
        padding: '15px',
        borderRadius: '4px',
        border: '1px solid #f5c6cb'
      }}>
        <strong>Error:</strong> {error}
      </div>
    );
  }

  if (!result) return null;

  const containerStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)'
  };

  const sectionStyle = {
    marginBottom: '20px',
    padding: '15px',
    backgroundColor: '#f8f9fa',
    borderRadius: '4px',
    border: '1px solid #dee2e6'
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse'
  };

  const cellStyle = {
    padding: '8px',
    borderBottom: '1px solid #ddd',
    textAlign: 'left'
  };

  const formatValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return <em style={{ color: '#6c757d' }}>Not available</em>;
    }
    return value;
  };

  return (
    <div style={containerStyle}>
      <h3 style={{ marginTop: 0, color: '#333', borderBottom: '2px solid #3b82f6', paddingBottom: '10px' }}>
        Carrier Information
      </h3>
      
      {result.lerg6 && (
        <div style={sectionStyle}>
          <h4 style={{ marginTop: 0, color: '#495057' }}>LERG 6 - Number Assignment</h4>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold', width: '30%' }}>Area Code (NPA)</td>
                <td style={cellStyle}>{formatValue(result.lerg6.NPA)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Exchange (NXX)</td>
                <td style={cellStyle}>{formatValue(result.lerg6.NXX)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>LATA</td>
                <td style={cellStyle}>{formatValue(result.lerg6.LATA)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>LATA Name</td>
                <td style={cellStyle}>{formatValue(result.lerg6['LATA NAME'])}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Operating Company Number (OCN)</td>
                <td style={cellStyle}>{formatValue(result.lerg6.OCN)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Location Name</td>
                <td style={cellStyle}>{formatValue(result.lerg6['LOC NAME'])}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Location State</td>
                <td style={cellStyle}>{formatValue(result.lerg6['LOC STATE'])}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Switch</td>
                <td style={cellStyle}>{formatValue(result.lerg6.SWITCH)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Rate Center</td>
                <td style={cellStyle}>{formatValue(result.lerg6['RC ABBRE'])}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {result.lerg1 && (
        <div style={sectionStyle}>
          <h4 style={{ marginTop: 0, color: '#495057' }}>LERG 1 - Carrier Details</h4>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold', width: '30%' }}>OCN Number</td>
                <td style={cellStyle}>{formatValue(result.lerg1['OCN_#'])}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Company Name</td>
                <td style={cellStyle}>{formatValue(result.lerg1.OCN_NAME)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Abbreviated Name</td>
                <td style={cellStyle}>{formatValue(result.lerg1.ABBRE_OCN_NAME)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>State</td>
                <td style={cellStyle}>{formatValue(result.lerg1.OCN_STATE)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Category</td>
                <td style={cellStyle}>{formatValue(result.lerg1.CATEGORY)}</td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Address</td>
                <td style={cellStyle}>
                  {result.lerg1.ADDRESS1 && (
                    <div>
                      {result.lerg1.ADDRESS1}<br/>
                      {result.lerg1.ADDRESS2 && <>{result.lerg1.ADDRESS2}<br/></>}
                      {result.lerg1.CITY}, {result.lerg1.STATE} {result.lerg1.ZIP}
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ ...cellStyle, fontWeight: 'bold' }}>Phone</td>
                <td style={cellStyle}>{formatValue(result.lerg1.PHONE)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {!result.lerg6 && !result.lerg1 && (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#6c757d'
        }}>
          No carrier information found for this number.
        </div>
      )}
    </div>
  );
}

export default ResultDisplay; 